export default "__VITE_ASSET__COaDUWZ5__"